import type { SxProps, Theme } from '@mui/material';

export const cardStyles: SxProps<Theme> = (theme: Theme) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 2,
  boxShadow: 'none',
});

export const headerContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  px: 3,
  pt: 3,
  pb: 2,
};

export const titleContainer: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
};

export const subtitleTypography: SxProps<Theme> = {
  fontSize: '14px',
  lineHeight: 1.5,
  margin: 0,
};

export const controlsContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
};

export const viewToggleGroup: SxProps<Theme> = (theme: Theme) => ({
  '& .MuiButton-root': {
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 400,
    borderColor: theme.palette.divider,
    color: theme.palette.text.primary,
    '&.MuiButton-contained': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.08)'
          : 'rgba(0, 0, 0, 0.08)',
    },
  },
});

export const titleTypography: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: 1.5,
  margin: 0,
};

export const formControl: SxProps<Theme> = {
  minWidth: 150,
};

export const tableSortLabel: SxProps<Theme> = (theme: Theme) => ({
  '& .MuiTableSortLabel-icon': {
    color: theme.palette.text.secondary,
  },
  '&.Mui-active .MuiTableSortLabel-icon': {
    color: theme.palette.text.primary,
  },
});

export const loadingErrorCell: SxProps<Theme> = {
  py: 4,
};

export const paginationContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  py: 3,
};

export const pagination: SxProps<Theme> = (theme: Theme) => ({
  '& .MuiPaginationItem-root': {
    color: theme.palette.text.primary,
    '&.Mui-selected': {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.16)'
          : 'rgba(0, 0, 0, 0.16)',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, 0.24)'
            : 'rgba(0, 0, 0, 0.24)',
      },
    },
    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.08)'
          : 'rgba(0, 0, 0, 0.08)',
    },
  },
});

export const tableContainer: SxProps<Theme> = {
  mb: 4,
};

export const table: SxProps<Theme> = {
  tableLayout: 'fixed',
};

export const nameColumn: SxProps<Theme> = {
  width: '25%',
};

export const numericColumn: SxProps<Theme> = {
  width: '25%',
  minWidth: 100,
};

